import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class Deliveries extends Component{
  constructor() {
    super();
    this.state = {
      deliveries: [],
    }
  }

  componentDidMount() {
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch("/api/admin/deliveries/", {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(deliveries => {
            this.setState({deliveries: deliveries})
          })
        }  else {
          console.log("Server Error!");
        }
      })
  }

  render() {
    return(
      <div className="Deliveries">
        <h1>Deliveries</h1>
        <Link
          className="Add-btn"
          to="/backoffice/deliveries/extra">
          Extra delivery
        </Link>
        <div className="Products-body">
          <table>
            <thead>
              <tr>
                <th>Delivery</th>
                <th>Month</th>
                <th>Created</th>
                <th>Packet</th>
                <th>Total</th>
                <th>Redigera</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.deliveries.map(item => {
                  return(
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.month_name}</td>
                      <td>{item.date}</td>
                      <td>{item.packets}</td>
                      <td>{item.total}kr</td>
                      <td>
                        <Link
                          to={`/backoffice/deliveries/${item.id}`}
                          className="table-button">
                          Granska
                        </Link>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default Deliveries;



// WEBPACK FOOTER //
// ./src/containers/admin/containers/Deliveries.jsx